module.exports = __webpack_public_path__ + "img/payfort.6bcc2e62.png";